/*
    forest-classes.js

    This contains the Svelte store objects.
    These are used to fill the TreeViewers, Chips and SearchBars.
    Selecting or deselecting nodes will notify the other components.

    Nodes
    Keywords
    Labels

    usage:  search.taxonomies[tcare-taxonomy-1].forest.items

*/

class ForestObject {
    constructor (parent) {
        this.parent = parent;               // parent is a Taxonomy object
        this.items = [];                    // the "nodes" from the API 
        this.tempForest = [];               // used for easier tree traversals
        this.tempKeywords = [];             // used for easier tree traversals
    }

    setItems(data) {
        this.items = data;
    }

    getItems() {
        return this.items;
    }

    // findNodeByLabel(label) {
    //     return null;
    // }

    // findNodeByKeyword(keyword) {
    //     return null;
    // }

    // call when artificially adding first child to a category
    createFirstChildNode(node) {
        const newNode = {};
        newNode.label = node.label;
        newNode.keyword = node.keyword;
        newNode.children = null;
        newNode.color = node.color;
        newNode.isSelected = false;
        newNode.isClosed = true;
        newNode.isFiltered = false;         // new 10/17
        return newNode;
    };

    // caution - this creates "first-child" node under Category nodes
    // must add category as its first child node
    // 06/13 - control this behavior with a flag?
    walkInitItems(node) {
        node.serviceIds = [];                                   // for TaxonomyMenu
        // console.log('init serviceIds for: ' + node.keyword);

        if (node.children) {
            node.isClosed = true;
            
            // MUST ARTIFICIALLY ADD FIRST CHILD HERE!!! 
            // this is a hack - should be in the JSON already
            // let newChild = this.createFirstChildNode(node);
            // node.children.unshift(newChild);
    
            for (const child of node.children) {
                child.isSelected = false;
                child.isFiltered = false;                       // new 10/17
                child.color = this.parent.color;
                this.walkInitItems(child);                      // recursive call
            }
        } else {
        }
    }

    // caution - this creates "first-child" node under Category nodes
    // process the nodes, add props like .isSelected
    initItems() {
        //console.log('ForestObject.initItems');
        this.tempForest = [];
        for (const node of this.items) {
            this.walkInitItems(node)
        }
    }

    // NODES

    // TODO: remove tempForest[] and just pass temp array to recursice calls
    
    // return all the nodes for one forest
    // avoid category duplicates (push only first child)
    walkGetAllNodes(node) {
        this.tempForest.push(node);                    // no test needed
        if (node.children) {
            for (const child of node.children) {
                //this.tempForest.push(child);                    // no test needed
                this.walkGetAllNodes(child);                    // recursive call
            }
        }
    }

    getAllNodes() {
        this.tempForest = [];
        for (const node of this.items) {
            this.walkGetAllNodes(node)
        }
        return this.tempForest;
    }




    walkGetSelectedNodes(node) {
        if (node.isSelected) this.tempForest.push(node);
        if (node.children) {
            for (const child of node.children) {
                this.walkGetSelectedNodes(child);               // recursive call
            }
        }
    }

    getSelectedNodes() {
        this.tempForest = [];
        for (const node of this.items) {
            this.walkGetSelectedNodes(node)
        }
        return this.tempForest;
    }




    walkSelectAllNodes(node, isSelected) {
        node.isSelected = isSelected;
        if (node.children) {
            for (const child of node.children) {
                this.walkSelectAllNodes(child, isSelected);               // recursive call
            }
        }
    }

    selectAllNodes(isSelected) {
        for (const node of this.items) {
            this.walkSelectAllNodes(node, isSelected)
        }
    }    




    // new 10/17
    walkFilterAllNodes(node, isFiltered) {
        node.isFiltered = isFiltered;
        if (node.children) {
            for (const child of node.children) {
                this.walkFilterAllNodes(child, isFiltered);               // recursive call
            }
        }
    }

    // new 10/17
    filterAllNodes(isFiltered) {
        for (const node of this.items) {
            this.walkFilterAllNodes(node, isFiltered)
        }
    }    

    // new 10/17
    walkGetFilteredNodes(node) {
        if (node.isFiltered) this.tempForest.push(node);
        if (node.children) {
            for (const child of node.children) {
                this.walkGetFilteredNodes(child);               // recursive call
            }
        }
    }

    // new 10/17
    getFilteredNodes() {
        this.tempForest = [];
        for (const node of this.items) {
            this.walkGetFilteredNodes(node)
        }
        return this.tempForest;
    }



    // new 10/17
    walkGetFilteredChildren(node) {
        if (node.isFiltered) this.tempForest.push(node);
        if (node.children) {
            for (const child of node.children) {
                this.walkGetFilteredChildren(child);               // recursive call
            }
        }
    }

    getFilteredChildren(node) {
        this.tempForest = [];
        if (!node.children) return [];
        for (const child of node.children) {
            this.walkGetFilteredChildren(child);
        }
        return this.tempForest;
    }

    // KEYWORDS

    walkGetAllKeywords(node) {
        this.tempKeywords.push(node.keyword);
        if (node.children) {
            for (const child of node.children) {
                //this.tempKeywords.push(child.keyword);
                this.walkGetAllKeywords(child);
            }
        }
    }

    // only needs to be called once
    getAllKeywords() {
        this.tempKeywords = [];
        for (const node of this.items) {
            this.walkGetAllKeywords(node)
        }
        return this.tempKeywords;
    }

    
    walkGetSelectedKeywords(node) {
        if (node.isSelected) this.tempKeywords.push(node.keyword);
        if (node.children) {
            for (const child of node.children) {
                this.walkGetSelectedKeywords(child);               // recursive call
            }
        }
    }

    getSelectedKeywords() {
        this.tempKeywords = [];
        for (const node of this.items) {
            this.walkGetSelectedKeywords(node)
        }
        return this.tempKeywords;
    }

    // new 06/14

    walkClearServiceIds(node) {
        node.serviceIds = [];
        if (node.children) {
            for (const child of node.children) {
                this.walkClearServiceIds(child);               // recursive call
            }
        }
    }

    clearServiceIds() {
        for (const node of this.items) {
            this.walkClearServiceIds(node)
        }
    }    

    // new 06/14

    walkGetAllItemKeywords(item) {
        this.tempKeywords.push(item.keyword);
        if (item.children) {
            for (const child of item.children) {
                this.walkGetAllItemKeywords(child);
            }
        }
    }

    getAllItemKeywords(item) {
        this.tempKeywords = [item.keyword];
        if (!item.children) return;
        for (const child of item.children) {
            this.walkGetAllItemKeywords(child)
        }
        return this.tempKeywords;
    }

    getAllItemKeywordsCount(item) {
        return this.getAllItemKeywords(item).length;
    }

    getAllLabels() {
        const allNodes = this.getAllNodes();
        return allNodes.map(node => node.label);
    }

    getTopLevelItems() {
        return this.items;
    }


}

export default ForestObject;
